/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import {
	AsyncJSMOperationsHorizontalNav,
	LazyJSMOperationsHorizontalNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations/src/index.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskServicesRoute } from '@jira/router-routes__servicedesk-services-routes/src/servicedeskServicesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDeskServicesWithProjectContext, {
	LazyServicedeskServicesWithProjectContext,
} from './ui/services-with-project-context/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskServicesRouteEntry: Route = createEntry(servicedeskServicesRoute, () => ({
	group: 'servicedesk',
	ufoName: 'service-management.services',
	// eslint-disable-next-line no-restricted-syntax
	component: ServiceDeskServicesWithProjectContext,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncJSMOperationsHorizontalNav,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		workspaceResource,
		getConsolidationStateResource(),
	],

	forPaint: [
		LazyAtlassianNavigation,
		LazyJSMOperationsHorizontalNav,
		LazyServicedeskServicesWithProjectContext,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
